import { render, staticRenderFns } from "./itemGroupedItem.vue?vue&type=template&id=aeee4e96&scoped=true&"
import script from "./itemGroupedItem.vue?vue&type=script&lang=js&"
export * from "./itemGroupedItem.vue?vue&type=script&lang=js&"
import style0 from "./itemGroupedItem.vue?vue&type=style&index=0&id=aeee4e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeee4e96",
  null
  
)

export default component.exports